var _strong, _strong2, _strong3, _span;
import PropTypes from 'prop-types';
import React from 'react';
import { priceIndicator } from 'axl-config';
import { Glyphicon, Popover, OverlayTrigger, withOverlayTrigger } from 'reaxl';

/**
 *  FraudReport displays a trigger and will open a Fraud Report modal
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FilterPriceDisclaimer(_ref) {
  let {
    options = [],
    popoverPosition,
    popoverTriggerEvent
  } = _ref;
  const {
    disclaimer
  } = priceIndicator;

  // Function handles which disclaimer message to show on tool tip
  const hasExceptional = options.some(option => option.label.includes('Exceptional Price'));
  const popover = /*#__PURE__*/_jsxs(Popover, {
    id: "priceDisclaimer",
    className: "text-gray-base",
    children: [/*#__PURE__*/_jsxs("ul", {
      className: "list-unstyled",
      children: [hasExceptional && /*#__PURE__*/_jsxs("li", {
        children: [_strong || (_strong = /*#__PURE__*/_jsx("strong", {
          children: "Exceptional Price "
        })), disclaimer.exceptionalDisclaimer]
      }), /*#__PURE__*/_jsxs("li", {
        children: [_strong2 || (_strong2 = /*#__PURE__*/_jsx("strong", {
          children: "Great Price "
        })), disclaimer.greatDisclaimer]
      }), /*#__PURE__*/_jsxs("li", {
        children: [_strong3 || (_strong3 = /*#__PURE__*/_jsx("strong", {
          children: "Good Price "
        })), disclaimer.goodDisclaimer]
      })]
    }), disclaimer.genericDisclaimer]
  });
  return /*#__PURE__*/_jsx("div", {
    className: "row",
    children: /*#__PURE__*/_jsx("div", {
      className: "col-xs-12 padding-top-1",
      children: /*#__PURE__*/_jsx(OverlayTrigger, {
        trigger: popoverTriggerEvent,
        placement: popoverPosition,
        rootClose: true,
        overlay: popover,
        children: _span || (_span = /*#__PURE__*/_jsxs("span", {
          className: "text-link margin-horizontal-1",
          id: "dealInfo",
          children: [/*#__PURE__*/_jsx(Glyphicon, {
            glyph: "info"
          }), ' ', "More info"]
        }))
      })
    })
  });
}
export default withOverlayTrigger({
  defaultPosition: 'bottom',
  top: ['sm'],
  right: ['xs', 'landscape']
})(FilterPriceDisclaimer);